import { v4 as uuid } from 'uuid';

export class HistoryEntry {
  constructor(title: string, url: string) {
    this.id = uuid();
    this.eventTime = new Date();
    this.title = title;
    this.url = url;
  }
  id: string;
  eventTime: Date;
  title: string;
  url: string;
}
